import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import produce from 'immer';
import useObservable from 'packages/workspace/modules/helpers/hooks/useObservable';

import { AppAbilities, AppAbility } from 'packages/workspace/modules/helpers/contexts/abilities';
import _ from 'lodash';
import { ShiftNames } from 'packages/workspace/modules/algebra/constants';

interface IAbility {
  ability: AppAbility;
}

const initialState: IAbility = {
  ability: new AppAbilities(),
};

const ability$ = new BehaviorSubject(initialState);

export const AbilityStore = {
  /**
   * Update Ability.
   * @param rules
   * @param from
   */
  updateRules: (rules: any, from = 'any'): void => {
    const state = produce(ability$.value, (draftState) => {
      const existingRules = Array.from(new Set((AbilityStore.getAbilities().rules).map(JSON.stringify))).map(JSON.parse);
      const uniqueRules = Array.from(new Set(rules.map(JSON.stringify))).map(JSON.parse);
      const filteredOnExistingRules = uniqueRules.filter((obj1) => !existingRules.some((obj2) => _.isEqual(obj1, obj2)))
      if (from === 'omnichannel') {
        const filteredExistingRules = existingRules.filter((iRule) => iRule.subject !== ShiftNames.OMNICHANNEL_SHIFT)
        draftState.ability.update(Array.from(new Set([...filteredExistingRules, ...uniqueRules].map(JSON.stringify))).map(JSON.parse));
      } else {
        draftState.ability.update([...existingRules, ...filteredOnExistingRules]);
      }
    });
    ability$.next(state);
  },

  getAbilities: () => ability$.value.ability,

  clearRules: () => {
    const state = produce(ability$.value, (draftState) => {
      draftState.ability.update([]);
    });
    ability$.next(state);
  },
};

export default function useAbilitiesStore(): IAbility {
  return useObservable<IAbility>(ability$, ability$.value);
}
